import {isNotEmpty, mayBe} from './common';
import {VdkBookCopy} from '../../../types';

export const preparePeopleTable = ({person, flatnum}: VdkBookCopy) => {
    const title = '';

    const headers = [
        'ФИО, республика, край, город, дата рождения',
        'Когда и откуда прибыл',
        'Цель приезда и на какой срок',
        'Гражданство, паспорт',
        'Военная служба',
        'Квартира',
        'Дата регистрации',
        'Когда и куда выбыл',
    ];

    const rows = isNotEmpty(person)
            ? person.map((person, index) => [
                `${index + 1}. ${mayBe(person.lastName)} ${mayBe(person.firstName)} ${mayBe(
                        person.givenName
                )}, ${mayBe(person.birthPlace)} ${mayBe(person.birthDate, 'г.р.')}`,
                mayBe(person.fromAddr) || '-',
                mayBe(person.regType) || '-',
                `${mayBe(person.grajd)}, ${mayBe(person.document)}` || '-',
                mayBe(person.martState) || '-',
                mayBe(flatnum) || '-',
                mayBe(person.regDate) || '-',
                mayBe(person.outAddr) || '-',
            ])
            : [];

    const empty = 'Нет данных';

    return {title, headers, rows, empty};
};
